





























import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import { OptionData, ValueType } from '@/types';
@Component({
  components: { CompSelectBox },
})
export default class FormKeyword extends Vue {
  @PropSync('keywordType', { required: true })
  private keywordTypeSync: ValueType;
  
  @PropSync('keyword', { required: true })
  private keywordSync: string;
  
  @Prop({ required: true })
  private readonly selectOptions: OptionData<ValueType>[];
  
  @Prop({ default: false })
  private readonly needAll: boolean;
  
  private handleChange() {
    this.$emit('handle-change');
  }
  
  private handleBlur() {
    this.$emit('handle-blur');
  }
  
  private handleEnter() {
    this.$emit('handle-enter');
  }
}
